export const getTextFieldProps = (formik, fieldName, readOnly) => {
  return {
    ...formik.getFieldProps(fieldName),
    error: formik.touched[fieldName] && Boolean(formik.errors[fieldName]),
    helperText: formik.touched[fieldName] && formik.errors[fieldName],
    ...(readOnly && {
      onChange: undefined,
      InputProps: {
        readOnly: readOnly,
      },
    }),
  };
};

export const getSelectFieldProps = (formik, fieldName, readOnly) => {
  return {
    value: formik.values[fieldName],
    onChange: (newValue) => formik.setFieldValue(fieldName, newValue),
    error: formik.touched[fieldName] && formik.errors[fieldName],
    ...(readOnly && {
      onChange: undefined,
      readOnly: true,
    }),
  };
};

export const getDateRangePickerFieldProps = (formik, fieldName, readOnly) => {
  return {
    value: formik.values[fieldName],
    onChange: readOnly
      ? undefined
      : (newValue) => formik.setFieldValue(fieldName, newValue),
  };
};

export const getCheckboxFieldProps = (formik, fieldName, readOnly) => {
  return {
    checked: formik.values[fieldName],
    onChange: readOnly
      ? undefined
      : (e) => formik.setFieldValue(fieldName, e.target.checked),
    readOnly,
  };
};
